import { z } from "zod";
/** Deliberately has no SSN, bank, card or password fields. */
export const CustomerInput = z.object({
    name: z.string().trim().min(1).max(120),
    phone: z.string().trim().max(40).optional(),
    email: z.union([z.literal(""), z.string().trim().max(200).email()]).optional(),
    stateCode: z.string().length(2),
    zip: z.union([z.literal(""), z.string().regex(/^\d{5}$/)]).optional(),
    preferredContact: z.enum(["phone", "email", "sms"]),
});
/** Body of PATCH /api/cases/:id/customer: any customer fields; an empty phone, email or ZIP clears it. */
export const CustomerUpdate = CustomerInput.partial().strict()
    .refine((v) => Object.values(v).some((x) => x !== undefined), { message: "Nothing to update" });
export const CaseUrgency = z.enum(["low", "normal", "high", "emergency"]);
export const CaseStatus = z.enum(["open", "waiting", "closed"]);
export const CaseSource = z.enum(["call", "web_callback", "referral"]);
export const CaseCreate = z.object({
    customerId: z.string().min(1).optional(), customer: CustomerInput.optional(),
    title: z.string().trim().min(1).max(200), problemId: z.string().nullable().optional(),
    summary: z.string().trim().max(5000).optional(), urgency: CaseUrgency.default("normal"),
    source: CaseSource.default("call"),
}).refine((v) => v.customerId || v.customer, { message: "customerId or customer is required" });
export const CaseUpdate = z.object({
    title: z.string().trim().min(1).max(200).optional(), problemId: z.string().nullable().optional(),
    summary: z.string().trim().max(5000).optional(), urgency: CaseUrgency.optional(), status: CaseStatus.optional(),
});
export const CaseProgramStatus = z.object({
    programId: z.string().min(1), stateCode: z.string().length(2).nullable().optional(),
    status: z.enum(["recommended", "referred", "applied", "approved", "denied", "withdrawn"]),
    note: z.string().trim().max(1000).optional(),
});
export const NoteInput = z.object({ body: z.string().trim().min(1).max(10000) });
/** `updatedAt` is the value the editor loaded; a mismatch means someone saved first (409). */
export const NoteUpdate = z.object({ body: z.string().trim().min(1).max(10000), updatedAt: z.string().min(1) });
/** Body of PUT /api/cases/:id/programs/:programId (the program id is in the path). */
export const CaseProgramUpsert = CaseProgramStatus.omit({ programId: true }).extend({ status: CaseProgramStatus.shape.status.default("recommended") });
export const FollowupInput = z.object({ dueAt: z.string().datetime(), note: z.string().trim().max(500).optional() });
export const FollowupUpdate = z.union([
    z.object({ doneAt: z.string().datetime().nullable() }).strict(),
    z.object({ dueAt: z.string().datetime(), note: z.string().trim().max(500).optional() }).strict(),
]);
export const FollowupQuery = z.object({ due: z.enum(["today", "overdue", "all"]).default("all"), tz: z.string().max(64).default("America/New_York") });
export const InteractionInput = z.object({
    kind: z.enum(["call", "email", "note", "sms"]), direction: z.enum(["in", "out"]),
    summary: z.string().trim().max(1000).optional(),
});
export const CaseScope = z.enum(["open", "mine", "closed"]);
export const CaseReassign = z.object({ userId: z.string().min(1) });
//# sourceMappingURL=cases.js.map